<template>
    <div>
        <div class="main-text text-container">
            <v-row>
                <v-col>
                    <iframe :src="url" ref="iframe"
                        @load="onIframeLoad">

                    </iframe>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'App',
        components: {
        },
        data: () => ({
        }),
        computed: {
            language() {
                return this.$store.getters.getLanguage
            },
            url() {
                if (this.language === 'en') {
                    return '/crm/checkout/'
                }

                return '/crm/el/checkout-2/'
            }
        },
        methods: {
        onIframeLoad() {
            const iframe = this.$refs.iframe;
            if (!iframe) return;

            try {
                const doc = iframe.contentWindow.document;

                // Calculate height
                const height =
                    doc.documentElement.scrollHeight + 120 ||
                    doc.body.scrollHeight + 120;

                iframe.style.height = height + 'px';
            } catch (e) {
                // console.warn('Cannot access iframe contents (cross-origin).');
            }
        }
    }
    }
</script>
<style scoped>
.heading {
    color: #5FA936;
    font-size: 36px;
    font-weight: 700;
}

.head-container{
    background-image: url("~@/assets/about_a_head.png");
    height: 380px;
    width: 100%;
    z-index: 0;
    color: #fff;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-shadow: 0px 0px 20px #0304036b;
    margin-top: -50px;
}

.head-text-main {
    font-weight: 700;
    font-size: clamp(28px, 7vw, 96px);
}

.head-text-secondary {
    font-size: 32px;
}

.main-text {
    color: #646464;
    font-size: 16px;
    line-height: 26px;
}
.text-container {
    max-width: 90%;
    margin: auto;
}

.green-text {
    color: #006600;
    font-weight: bold;
}
iframe {
    border: 0px;
    width: 100%;
    height: 100vh;
    margin: auto;
}
</style>
